<template>
    <div class="footer" :style="{background:$store.state.app.footerColor}">
        <div class="content">
            <div class="left">
                <div class="navList">
                    <div class="item" v-for="(item,index) in navList" :key="index" @click.stop="onPath(item.path)">{{item.name}}</div>
                </div>
                <div class="danwei">
                    <div class="item">版权所有© 深圳市前海智慧版权创新发展研究院&nbsp;&nbsp;&nbsp;版权家提供技术支持</div>
                </div>
                <div class="beian">
<!--                    <div class="item">备案号：粤ICP备2021176437号-1</div>-->
                    <p>备案号：<a class="footer_link" style="text-decoration: underline; color: black;" href="https://beian.miit.gov.cn/#/Integrated/index"
                                                                            target="_black">粤ICP备2021176437号-1</a></p>
                    <div class="item">
                        <!--<img class="img" src="./images/gan.png" alt="">
                        <div>粤公网安备 44010408881768号XXXXXXXXXXXXXXXXXX</div>-->
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="imgBox">
                    <div class="item">
                        <img class="img" src="./images/ewm.jpg" alt="">
                        <div>公众号</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "homeFooter",
        data(){
            return {
                navList: [
                    {
                        name: "首页",
                        path: '/'
                    },

                    {
                        name: "版权登记",
                        path: '/gananCopyrightRegistration'
                    },
                    {
                        name: "版权服务",
                        path: '/gananElectronic',
                        children: [
                            {
                                name: '电子数据存证',
                                path: '/gananElectronic'
                            },
                            {
                                name: '版权预登记',
                                path: '/gananPreRegistration'
                            },
                            {
                                name: '软件著作权登记',
                                path: '/gananSoftwareCopyright'
                            },
                            {
                                name: '版权监测',
                                path: '/gananCopyrightMonitoring'
                            },
                            {
                                name: '法律服务',
                                path: '/gananCopyrightRights'
                            },
                            {
                                name: '侵权取证',
                                path: '/gananWebForensics'
                            }
                        ],
                    },
                    {
                        name: "IP授权",
                        path: '/gananIpAuth'
                    },
                    {
                        name: "版权资讯",
                        path: '/gananNewCenter'
                    },
                    {
                        name: "公示查询",
                         path: 'https://blockchain.qh-copyright.cn/pubPage',
                        open: true
                    },

                    {
                        name: "关于我们",
                        path: '/gananAboutUs'
                    },
                ],
            }
        },
        methods: {
            onPath(path) {
              if(path.startsWith('http')){
                window.open(path)
                return;
              }
                if (path) {
                    this.$router.push(path)
                }
            },
        },
        watch: {
            $route(to, from) {

            }
        }
    };
</script>

<style lang="less" scoped>
.footer{
    background: #fff;
    .content{
        display: flex;
        align-items: center;
        height: 208px;
        max-width: 1200px;
        margin: auto;
        .left{
            flex: 1;
            .navList{
                display: flex;
                align-items: center;
                .item{
                    font-size: 16px;
                    color: #333333;
                    position: relative;
                    padding: 0 20px;
                    cursor: pointer;
                    font-family: 'AlibabaPuHuiTi';
                    &:first-child{
                        padding-left: 0;
                    }
                    &:last-child{
                        padding-right: 0;
                        &::after{
                            content:  '';
                            display: none;
                        }
                    }
                    &::after{
                        content:  '';
                        position: absolute;
                        right: 0;
                        top: 50%;
                        height: 50%;
                        background: #333;
                        width: 1px;
                        transform: translate(0,-50%);
                    }
                }
            }
            .danwei{
                display: flex;
                align-items: center;
                margin-top: 37px;
                margin-bottom: 15px;
                .item{
                    font-size: 14px;
                    color: #999;
                    margin-right: 32px;
                    display: flex;
                    align-items: center;
                    .img{
                        width: 20px;
                        height: 20px;
                        margin-right: 4px;
                    }
                }
            }
            .beian{
               display: flex;
                align-items: center;
                margin-top: 15px;
                .item{
                    font-size: 14px;
                    color: #999;
                    margin-right: 32px;
                    display: flex;
                    align-items: center;
                    .img{
                        width: 20px;
                        height: 20px;
                        margin-right: 4px;
                    }
                }
            }
        }
        .right{
            .imgBox{
                display: flex;
                .item{
                    font-size: 12px;
                    color: #999999;
                    text-align: center;
                    .img{
                        width: 112px;
                        height: 112px;
                        margin-bottom: 8px;
                    }
                }
            }
        }
    }

}
</style>
